'use client';

import { useTranslations } from 'next-intl';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MaintenanceClouds } from '@/app/[locale]/maintenance/components/MaintenanceClouds';
import { Beardman404 } from '~/components/Beardman/Beardman404/Beardman404';
import { TabsFilterValue } from '../../types/project/tabs';
import { ProjectCard } from '../project/ProjectCard';
import { useProjectInteractionsContext } from '../provider/ProjectInteractionsProvider';
import { AnnouncementPreview } from './AnnouncementPreview';

export function AnnouncementList() {
  const t = useTranslations('PROJECT.NEWS');
  const { collections, fetchInteractions } = useProjectInteractionsContext();

  const announcements = collections[TabsFilterValue.NEWS]?.['hydra:member'];
  const nextPage = collections[TabsFilterValue.NEWS]?.['hydra:view']?.['hydra:next'];

  return (
    <InfiniteScroll
      dataLength={announcements?.length || 0}
      next={async () => await fetchInteractions(
        TabsFilterValue.NEWS,
        nextPage,
      )}
      hasMore={!!nextPage}
      loader={null}
      style={{ height: 'initial', overflow: 'visible' }}
    >
      {announcements?.length > 0
        ? (
            <div
              data-testid="announcement-list"
              className="announcement-list centered-content"
            >
              <ul className="interactions-list__container">
                {announcements.map(interaction => (
                  <li key={`${TabsFilterValue.NEWS}-${interaction.id}`}>
                    <ProjectCard interaction={interaction}>
                      <AnnouncementPreview interaction={interaction} />
                    </ProjectCard>
                  </li>
                ))}
              </ul>
            </div>
          )
        : (
            <div className="maintenance-page__wrapper">
              <div className="maintenance-page__message">
                <p className="vp-title-m">
                  {t.rich('NO_INTERACTION')}
                </p>
                <Beardman404 />
                <MaintenanceClouds />
              </div>
            </div>
          )}
    </InfiniteScroll>
  );
};
